export { VideoPlayer } from './components/VideoPlayer'
export { MSEVideoPlayer } from './components/MSEVideoPlayer'

export { useCameraFeed } from './hooks/useCameraFeed'
export { useMSEStream } from './hooks/useMSEStream'
export { useMSEPlayer } from './hooks/useMSEPlayer'
export { useIncidentVideo } from './hooks/useIncidentVideo'
export { useFindDeviceFeed } from './hooks/useFindDeviceFeed'
export { useVideoFrame } from './hooks/useVideoFrame'
export { useStreamLatencyTracker } from './hooks/useStreamLatencyTracker'

export type { CameraStreamStateIProps } from './types/types'
export { IncidentPlayerError } from './types/types'
export type { VideoDimensionsIProps } from './types/types'
export { VideoFeedEvent, VideoControlsAction } from './types/types'

export {
  DRAWER_VIDEO_PLAYER_WIDTH,
  DRAWER_VIDEO_PLAYER_HEIGHT,
  VALIDATION_VIDEO_PLAYER_WIDTH,
  VALIDATION_VIDEO_PLAYER_HEIGHT,
} from './constants/dimensions'
